import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthStoreModule } from './auth-store/auth-store.module';
import { AutoLogoutService } from './auto-logout/auto-logout.service';

@NgModule({
    imports: [AuthStoreModule],
    exports: [AuthStoreModule],
    providers: [AutoLogoutService, CookieService]
})
export class SharedAuthLibModule {}
